import { SB } from '@play-co/replicant';

export const careSchema = {
  care: SB.object({
    careActionCount: SB.number().min(0).default(0),
  }),
};
